import React, { useEffect, useState } from "react";
import { FreeMode, Navigation, Autoplay } from "swiper/modules";
import apiClient from "../api";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Link } from "react-router-dom";
import { FaIndianRupeeSign, FaLocationDot } from "react-icons/fa6";
import { FaBuilding } from "react-icons/fa";

const PuneSubregionSlider = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [property, setProperty] = useState({});
  const [propertySingle, setPropertySingle] = useState({});
  const [subject, setSubject] = useState("");

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        const res = await apiClient.get(`listing/propertysubregion/${data}`);
        if (res.status === 200) {
          setPropertySingle(res.data[0]);
          setProperty(res.data);
          setSubject(res.data[0].devlopername);
          // setShowMore(true);

          setLoading(false);
        }
      } catch (error) {
        // setError(true);
        setLoading(false);
      }
    };

    fetchProperties();
  }, [data]);
  const [popupData, setPopupData] = useState("");

  const handleButtonClick = (dataName) => {
    // Set the value you want to send to the Popup
    console.log(dataName);
    setPopupData(dataName);
  };

  return (
    <>
      <Swiper
        className="region-button"
        spaceBetween={10} // Space between slides
        modules={[FreeMode, Autoplay, Navigation]}
        navigation={true}
        autoplay={{
          delay: 2000, // Delay between slides in milliseconds (e.g., 3 seconds)
          disableOnInteraction: false, // Allow autoplay to continue even after user interaction
        }}
        style={{ padding: "10px 10px" }}
        breakpoints={{
          425: {
            slidesPerView: 1, // Show 2 slides on small screens
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2, // Show 4 slides on tablets
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 2, // Show based on content on larger screens
            spaceBetween: 20,
          },
        }}
      >
        {Array.isArray(property) &&
          property.map((discountedProperty, index) => (
            <div className="col-md-12">
              <SwiperSlide key={index}>
                <div className="discounted-deal-property-div">
                  <Link
                    to={`/pune/property-detail/${discountedProperty.slug}`}
                    className="view-detail-btn-property-home-txt"
                  >
                    <img
                      src={discountedProperty.imageUrls}
                      className="discounted-property-img img-fluid "
                      alt={`Discounted property ${discountedProperty.name}`}
                    />
                  </Link>
                  <div className="disocunted-property-specs-div">
                    <p className="discounted-property-name">
                      <Link
                        to={`/pune/property-detail/${discountedProperty.slug}`}
                        className="view-detail-btn-property-home-txt"
                      >
                        {discountedProperty.name}
                      </Link>
                    </p>
                    <p className="discounted-property-address-txt">
                      <FaLocationDot />
                      <span>{discountedProperty.address}</span>
                    </p>
                    <p className="discounted-property-BHK-txt">
                      <FaBuilding />
                      {discountedProperty.BHK &&
                      Array.isArray(discountedProperty.BHK) ? (
                        discountedProperty.BHK.map((bhk, idx) => (
                          <span key={idx}>
                            {bhk}
                            {idx < discountedProperty.BHK.length - 1 && ", "}
                          </span>
                        ))
                      ) : (
                        <span>Loading data...</span>
                      )}{" "}
                      BHK
                    </p>
                    <p className="discounted-property-price">
                      <FaIndianRupeeSign />
                      <span>{discountedProperty.price}</span>
                    </p>
                    <div className="property-devloper-btn-home-div">
                      <Link
                        to={`/pune/property-detail/${discountedProperty.slug}`}
                        className="view-detail-btn-property-home"
                      >
                        View Details
                      </Link>
                      <button
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        className="get-call-btn-property-home-page"
                        onClick={() =>
                          handleButtonClick(discountedProperty.name)
                        }
                      >
                        Enquire Now
                      </button>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </div>
          ))}
      </Swiper>
    </>
  );
};

export default PuneSubregionSlider;
